export function checkIfEmailIdentical(control) {
  const { value } = control;
  return (
    value.confirmEmail === value.email ||
    // avoid displaying the message error when values are empty
    !value.confirmEmail ||
    !value.email
  );
}
